import gql from "graphql-tag";

export default gql`
  query SayOnPayHistory($tickerSymbol: TickerSymbol!, $country: SecurityCountry!) {
    issuerByTickerSymbol(tickerSymbol: $tickerSymbol, country: $country) {
      ... on AmericanCompanyIssuer {
        _id
        sayOnPayHistory {
          fiscalYear
          reportSource
          reportDate
          accessionNumber
          filingSource {
            accessionNumber
            primaryDocumentHref
          }
          sayOnPayFor
          sayOnPayAgainst
          sayOnPayAbstention
          sayOnPayBrokerNonVotes
        }
      }
    }
  }
`;
